import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getOpsColor, triggerGAEvent } from "../../../utils/helper";
import { StyledSubmitButton } from "../../Report/new/Footer/Footer-styled";
import { StyledBody } from "../SidebarMenu/SidebarMenu-styled";

const FinaliseExport = ({ onDownload, config, loading, t }) => {
  const { activeModule } = useSelector((state) => state);
  const opsColor = useMemo(
    () => getOpsColor(config, activeModule),
    [config, activeModule]
  );
  return (
    <StyledBody style={{ justifyContent: "center" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <p style={{ textAlign: "justify" }}>
          {t("print.final.questions.1.title")}
        </p>
        <StyledSubmitButton
          onClick={() => {
            onDownload();

            triggerGAEvent({
              event: "client_action",
              params: {
                action: "print-map",
              },
            });
          }}
          bg={opsColor}
          disable={loading}
        >
          <span>{t("print.final.questions.1.options.export")}</span>
        </StyledSubmitButton>
      </div>
    </StyledBody>
  );
};

export default FinaliseExport;
